(function() {
  function initBundleBuilder() {
    const container = document.querySelector('.bundle-builder-container');
    if (!container) return;

    // Use scoped selectors within the container to avoid ID conflicts
    const totalDisplay = container.querySelector('#bundle-builder-total-count');
    const errorMsg = container.querySelector('#bundle-builder-error');
    const remainingMsg = container.querySelector('#bundle-builder-remaining');
    const mainQtyInput = container.querySelector('#bundle-builder-main-qty');
    const progressBar = container.querySelector('#bundle-builder-progress-bar');
    
    // Read dynamic settings from data attributes
    let bundleMinimum = parseInt(container.getAttribute('data-bundle-minimum'));
    if (isNaN(bundleMinimum) || bundleMinimum <= 0) bundleMinimum = 10;
    
    const bundlePricingType = container.getAttribute('data-bundle-pricing-type') || 'per_item';
    const productFormId = container.getAttribute('data-product-form-id');

    const getAddButton = () => {
      // Add button is usually outside the container, but within the product section
      const productSection = container.closest('product-info') || container.closest('.product') || document;
      return productSection.querySelector('button[name="add"]') || 
             productSection.querySelector('.product-form__submit') ||
             productSection.querySelector('[data-testid="AddToCartButton"]');
    };

    let isUpdating = false;
    const updateUI = () => {
      if (isUpdating) return;
      isUpdating = true;

      try {
        let total = 0;
        container.querySelectorAll('.bundle-builder-qty').forEach(input => {
          const val = parseInt(input.value) || 0;
          total += val;
          
          // Toggle active state for the card
          const item = input.closest('.bundle-builder-item');
          if (item) {
            if (val > 0) {
              item.classList.add('is-active');
            } else {
              item.classList.remove('is-active');
            }
          }
        });

        // Update Total Display
        if (totalDisplay) {
          totalDisplay.textContent = total;
        }

        // Update Progress Bar
        if (progressBar) {
          const progress = Math.min((total / bundleMinimum) * 100, 100);
          progressBar.style.width = progress + '%';
          
          if (total >= bundleMinimum) {
            progressBar.classList.add('complete');
          } else {
            progressBar.classList.remove('complete');
          }
        }

        // Update Remaining Counter
        if (remainingMsg) {
          const remaining = bundleMinimum - total;
          const remainingText = remainingMsg.querySelector('.bundle-builder-remaining-text');
          
          if (remainingText) {
            if (remaining > 0) {
              remainingText.textContent = `Select ${remaining} more bag${remaining !== 1 ? 's' : ''} to complete your bundle`;
              remainingMsg.classList.remove('ready');
            } else if (remaining === 0) {
              remainingText.textContent = "Your bundle is complete!";
              remainingMsg.classList.add('ready');
            } else {
              remainingText.textContent = `Minimum reached! (${total} bags selected)`;
              remainingMsg.classList.add('ready');
            }
          }
        }
        
        // Sync to Main Product Quantity
        if (mainQtyInput) {
          const targetQty = (bundlePricingType === 'fixed') ? 1 : total;
          if (mainQtyInput.value !== targetQty.toString()) {
            mainQtyInput.value = targetQty;
            mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // Handle Add Button State
        const addBtn = getAddButton();
        if (addBtn) {
          const isInvalid = total < bundleMinimum;
          addBtn.disabled = isInvalid;
          
          if (isInvalid) {
            addBtn.classList.add('disabled');
            addBtn.style.opacity = '0.5';
            addBtn.style.cursor = 'not-allowed';
          } else {
            addBtn.classList.remove('disabled');
            addBtn.style.opacity = '1';
            addBtn.style.cursor = 'pointer';
          }
          
          if (errorMsg) {
            errorMsg.style.display = (total > 0 && total < bundleMinimum) ? 'block' : 'none';
          }
        }
      } finally {
        isUpdating = false;
      }
    };

    container.addEventListener('click', function(e) {
      const btn = e.target.closest('.bundle-builder-btn');
      if (!btn) return;

      const input = btn.parentNode.querySelector('.bundle-builder-qty');
      let val = parseInt(input.value) || 0;

      if (btn.classList.contains('bundle-builder-plus')) {
        val++;
      } else if (btn.classList.contains('bundle-builder-minus') && val > 0) {
        val--;
      }

      input.value = val;
      
      // Update individual hidden properties for backend/fulfillment
      const flavor = input.dataset.flavor;
      if (val > 0) {
        input.setAttribute('name', `properties[${flavor}]`); // Hidden prefix '_'
        if (productFormId) input.setAttribute('form', productFormId);
      } else {
        input.removeAttribute('name');
      }

      // Generate a clean summary for the cart display
      let summaryParts = [];
      container.querySelectorAll('.bundle-builder-qty').forEach(qtyInput => {
        const q = parseInt(qtyInput.value) || 0;
        if (q > 0) {
          summaryParts.push(`${qtyInput.dataset.flavor} (${q})`);
        }
      });

      // Create or update the summary hidden input
      let summaryInput = container.querySelector('input[name="properties[Your Selection]"]');
      if (summaryParts.length > 0) {
        if (!summaryInput) {
          summaryInput = document.createElement('input');
          summaryInput.type = 'hidden';
          summaryInput.name = 'properties[Your Selection]';
          if (productFormId) summaryInput.setAttribute('form', productFormId);
          container.appendChild(summaryInput);
        }
        summaryInput.value = summaryParts.join(' • ');
      } else if (summaryInput) {
        summaryInput.remove();
      }

      updateUI();
    });

    updateUI();
    
    const observer = new MutationObserver((mutations) => {
      const shouldUpdate = mutations.some(m => 
        m.type === 'childList' && 
        Array.from(m.addedNodes).some(node => 
          node.nodeType === 1 && (node.querySelector('button[name="add"]') || node.name === 'add')
        )
      );
      if (shouldUpdate) updateUI();
    });
    
    const productInfo = container.closest('product-info') || container.parentElement;
    if (productInfo) {
      observer.observe(productInfo, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundleBuilder);
  } else {
    initBundleBuilder();
  }
})();
// Require enough flavour selections before submitting a bundle.
document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  const builders = document.querySelectorAll(
    '.bundle-builder-container'
  );

  for (const builder of builders) {
    const formId = builder.getAttribute('data-product-form-id');
    if (!formId || form.id !== formId) continue;

    const configuredMinimum = Number.parseInt(
      builder.getAttribute('data-bundle-minimum'),
      10
    );
    const minimum = configuredMinimum > 0
      ? configuredMinimum
      : 10;

    let selected = 0;
    builder.querySelectorAll('.bundle-builder-qty').forEach(input => {
      selected += Math.max(0, Number.parseInt(input.value, 10) || 0);
    });

    if (selected >= minimum) continue;

    event.preventDefault();
    event.stopImmediatePropagation();

    const message = builder.querySelector('.bundle-builder-error');
    if (message) {
      message.textContent =
        `Please choose flavours for at least ${minimum} bags before adding to cart.`;
      message.style.display = 'block';
      message.setAttribute('role', 'alert');
    }

    builder.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    const firstChoice = builder.querySelector('.bundle-builder-plus');
    if (firstChoice) firstChoice.focus();

    return;
  }
}, true);